import { render, staticRenderFns } from "./testIndex.vue?vue&type=template&id=1ff1a376&scoped=true"
import script from "./testIndex.vue?vue&type=script&lang=js"
export * from "./testIndex.vue?vue&type=script&lang=js"
import style0 from "./testIndex.vue?vue&type=style&index=0&id=1ff1a376&prod&lang=scss"
import style1 from "./testIndex.vue?vue&type=style&index=1&id=1ff1a376&prod&lang=scss&scoped=true"
import style2 from "./testIndex.vue?vue&type=style&index=2&id=1ff1a376&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ff1a376",
  null
  
)

export default component.exports